import { useContext } from 'react';
import {
  RadioGroupButton,
  type RadioGroupButtonProps,
} from '../RadioGroupButton';
import { NavbarContext } from './NavbarContext';

export type NavbarCenterControlsProps<T> = Pick<
  RadioGroupButtonProps<T>,
  'buttonsConfig' | 'onClick' | 'selected'
>;

export const NavbarCenterControls = <T,>({
  buttonsConfig,
  onClick,
  selected,
}: NavbarCenterControlsProps<T>) => {
  const { theme: navbarTheme } = useContext(NavbarContext);
  return (
    <div className="h-full w-full absolute flex items-center justify-center pointer-events-none">
      <div className="pointer-events-auto">
        <RadioGroupButton<T>
          buttonsConfig={buttonsConfig}
          onClick={onClick}
          selected={selected}
          theme={navbarTheme}
        />
      </div>
    </div>
  );
};
